/**
 * Learn more about theme events at
 * https://help.switchthemes.co/shapes/developer/theme-events/overview.html
 */

window.theme = window.theme || {};

window.theme.events = {
  version: '1.0',
};

document.addEventListener('theme:update:cart', async () => {
  document.dispatchEvent(new CustomEvent('shapes:cart:lock'));

  try {
    const response = await fetch(
      `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`
    );
    const data = await response.json();

    if (!data.status) {
      document.dispatchEvent(
        new CustomEvent('shapes:cart:update', {
          bubbles: true,
          detail: {
            response: {
              sections: {
                ...data,
              },
            },
          },
        })
      );
    }
  } catch (e) {
    console.error(e);
    document.getElementById('cart-errors').textContent =
      theme.strings.cartError;
    document.dispatchEvent(
      new CustomEvent('theme:cart:error:other', {
        detail: {
          message: theme.strings.cartError,
          error: e,
        },
      })
    );
  } finally {
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
  }
});

const getCartDrawerEl = () => {
  return document.querySelector('[data-cart-drawer]');
};

document.addEventListener('cart-will-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:opening', {
      detail,
    })
  );
});

document.addEventListener('cart-is-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:open', {
      detail,
    })
  );
});

document.addEventListener('cart-will-close', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closing', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('cart-is-closed', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closed', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('theme:open:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').closeAll();

    Alpine.store('modals').open('cart');
  }
});

document.addEventListener('theme:close:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').close('cart');
  }
});

const cartChangeEventHandler = (e) => {
  const { cartItemCount, itemsRootEl, lineItemEl, variantId, key } = e.detail;

  document.dispatchEvent(
    new CustomEvent('theme:cart:change', {
      detail: {
        type: e.type,
        cartItemCount,
        itemsRootEl,
        lineItemEl,
        variantId,
        key,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener('theme:product:add', cartChangeEventHandler);
document.addEventListener('theme:line-item:change', cartChangeEventHandler);

const cartErrorEventHandler = (e) => {
  document.dispatchEvent(
    new CustomEvent('theme:cart:error', {
      detail: {
        type: e.type,
        message: e.detail.message,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener(
  'theme:product:error:add-to-cart',
  cartErrorEventHandler
);

document.addEventListener('theme:line-item:error', cartErrorEventHandler);
document.addEventListener('theme:cart:error:other', cartErrorEventHandler);

/**
 * Set `window.themeEventsDebugMode` to `true` to log events
 * outside the theme editor
 */

if (Shopify.designMode || window.themeEventsDebugMode) {
  const themeEvents = [
    'theme:variant:change',
    'theme:product:add',
    'theme:line-item:change',
    'theme:cart:change',
    'theme:cart:update',
    'theme:cart-drawer:opening',
    'theme:cart-drawer:open',
    'theme:cart-drawer:closing',
    'theme:cart-drawer:closed',
    'theme:product:error:add-to-cart',
    'theme:line-item:error',
    'theme:cart:error:other',
    'theme:cart:error',
  ];

  const aggregateEvents = ['theme:cart:change', 'theme:cart:error'];

  for (const eventName of themeEvents) {
    let color;

    if (eventName.includes('error')) {
      color = '#ef4444';
    } else {
      color = '#22c55e';
    }

    const message = [
      `%c\u25CF %c${eventName}`,
      `color: ${color};`,
      'font-weight: bold;',
    ];

    if (aggregateEvents.includes(eventName)) {
      document.addEventListener(eventName, (e) => {
        console.groupCollapsed(...message);
        console.log(
          `Underlying event: %c${e.detail.type}`,
          'font-weight: bold;'
        );
        console.log('Event detail:', e.detail);
        console.groupEnd();
      });
    } else {
      document.addEventListener(eventName, (e) => {
        console.log(...message, e.detail);
      });
    }
  }
}

// ─── Checkout Funnel Tracking ─────────────────────────────────────────────
// Fire-and-forget via navigator.sendBeacon — nunca bloqueia o fluxo do carrinho.
// Gera sessionId uma vez e mantém em sessionStorage.
// Inclui value + currency obrigatórios para Meta Pixel / Conversions API.

function mmUuid() {
  return self.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

function mmGetCookie(name) {
  try {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : undefined;
  } catch (_) {
    return undefined;
  }
}

// Identificador persistente (localStorage, sobrevive entre sessões) usado como
// external_id de fallback para visitantes não logados — melhora Event Match
// Quality e permite deduplicação estável entre Pixel e Conversions API.
function mmGetVisitorId() {
  try {
    let id = localStorage.getItem('mm_visitor_id');
    if (!id) {
      id = mmUuid();
      localStorage.setItem('mm_visitor_id', id);
    }
    return id;
  } catch (_) {
    return undefined;
  }
}

document.addEventListener('theme:product:add', async (e) => {
  try {
    let sessionId;
    try {
      sessionId = sessionStorage.getItem('mm_session_id');
      if (!sessionId) {
        sessionId = mmUuid();
        sessionStorage.setItem('mm_session_id', sessionId);
      }
    } catch (_) {
      sessionId = mmUuid();
    }

    // ── Dados para deduplicação e advanced matching (Meta Pixel + CAPI) ──
    // eventId: compartilhado entre o disparo do Pixel (browser) e o evento
    // server-side que o backend do checkout envia via Conversions API.
    // Sem isso a Meta não conseguia desduplicar os dois eventos, o que
    // derrubava a cobertura de eventos (34%) e a pontuação de qualidade.
    const eventId = 'atc-' + mmUuid();
    const fbp = mmGetCookie('_fbp');
    const fbc = mmGetCookie('_fbc');
    const customer = (window.theme && window.theme.customer) || {};
    const externalId = customer.id ? String(customer.id) : mmGetVisitorId();
    const email = customer.email || undefined;

    // ── Extrair value + currency com fallback robusto ────────────────────
    // 1ª tentativa: cartPromise (mais preciso — inclui quantity)
    // 2ª tentativa: Alpine component currentVariant.price
    // 3ª tentativa: data-mm-price no DOM
    let value;
    let currency = 'BRL';
    const variantId = e.detail.variantId;

    try {
      const cart = await e.detail.cartPromise;
      const item = cart.items.find(i => String(i.variant_id) === String(variantId));
      if (item) {
        value = item.line_price / 100;
        currency = cart.currency || 'BRL';
      }
    } catch (_) {
      // fallback silencioso
    }

    // Fallback 2: Alpine component data
    if (value === undefined && e.detail.formEl && window.Alpine) {
      try {
        const alpineRoot = e.detail.formEl.closest('[x-data]');
        if (alpineRoot) {
          const data = Alpine.$data(alpineRoot);
          if (data && data.currentVariant && data.currentVariant.price != null) {
            value = (data.currentVariant.price * Number(data.quantity || 1)) / 100;
          }
        }
      } catch (_) { /* fallback silencioso */ }
    }

    // Fallback 3: data-mm-price no DOM (static)
    if (value === undefined) {
      try {
        const priceEl = document.querySelector('[data-mm-price]');
        if (priceEl) {
          const raw = priceEl.getAttribute('data-mm-price');
          if (raw) value = parseFloat(raw) / 100;
        }
      } catch (_) { /* fallback silencioso */ }
    }

    const payload = {
      sessionId,
      value,
      currency,
      variantId: variantId ? `gid://shopify/ProductVariant/${variantId}` : undefined,
      itemCount: e.detail.cartItemCount,
      // Campos usados pelo backend do checkout para enviar o evento
      // server-side à Conversions API com deduplicação e advanced matching.
      eventId,
      fbp,
      fbc,
      externalId,
      email,
      metadata: {
        origin: 'shopify-theme',
        source: 'add-to-cart',
        url: window.location.href,
      },
    };

    // Beacon para o backend próprio
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    navigator.sendBeacon('https://checkout.modernmood.com.br/api/checkout/cart/add', blob);

    // ── Meta Pixel / Conversions API ────────────────────────────────────
    // Dispara fbq com value e currency sempre preenchidos.
    // O script fbq já é injetado pelo app Facebook Channel via content_for_header.
    if (typeof fbq !== 'undefined' && value !== undefined && currency) {
      try {
        // Advanced matching: melhora Event Match Quality no Meta.
        // fbq faz o hash (SHA-256) de em/external_id automaticamente.
        const userData = {};
        if (email) userData.em = email;
        if (externalId) userData.external_id = externalId;
        if (Object.keys(userData).length) {
          fbq('set', 'userData', userData);
        }

        // Tenta extrair nome do produto do Alpine data (mais preciso)
        let contentName = document.title;
        if (e.detail.formEl && window.Alpine) {
          try {
            const alpineRoot = e.detail.formEl.closest('[x-data]');
            if (alpineRoot) {
              const data = Alpine.$data(alpineRoot);
              if (data && data.product && data.product.title) {
                contentName = data.product.title;
              }
            }
          } catch (_) { /* fallback usa document.title */ }
        }
        fbq(
          'track',
          'AddToCart',
          {
            content_ids: variantId ? [String(variantId)] : [],
            content_name: contentName,
            content_type: 'product',
            value: value,
            currency: currency,
          },
          { eventID: eventId }
        );
      } catch (_) { /* fbq pode falhar silenciosamente */ }
    }
  } catch (_) {
    // Tracking nunca quebra o fluxo do carrinho
  }
});
